@if (details) {
  <cms-item-view [details]="details">
    <cms-news-content [details]="details"></cms-news-content>
  </cms-item-view>
} @else {
  <div class="flex flex-center-start w-full h-full">
    <loader color="primary"></loader>
  </div>
}
